import { render, staticRenderFns } from "./MonthMenu.vue?vue&type=template&id=a0a8ff72&"
import script from "./MonthMenu.vue?vue&type=script&lang=js&"
export * from "./MonthMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports